import { CardHeader, CardTitle } from "@/components/ui/card";

interface AccessControlHeaderProps {
  onAddCode: () => void;
}

export const AccessControlHeader = ({ onAddCode }: AccessControlHeaderProps) => {
  return (
    <CardHeader>
      <CardTitle>Codes d'accès</CardTitle>
    </CardHeader>
  );
};